window.clearFormFields = function (objForm) {
	var i;
	for (i = 0; i < objForm.elements.length; i++) {
		if (objForm.elements[i].type.indexOf("radio") !== -1 || objForm.elements[i].type.indexOf("checkbox") !== -1) {
			objForm.elements[i].checked = false;
		} else if (objForm.elements[i].type.indexOf("text") !== -1) {
			objForm.elements[i].value = "";
		} else if (objForm.elements[i].type.indexOf("select") !== -1) {
			objForm.elements[i].selectedIndex = -1;
		}
	}
}

window.formatDate = function (date, pattern) {
	var newDateSplit;
	var newDate;
	var year;

	if (date === null || date === "" || pattern === null || pattern === "") {
		return "";
	}

	var re = new RegExp("^[0-9\\.-:,/ ]{1," + pattern.length + "}$");
	if (!date.match(re)) {
		return date;
	}

	if (pattern === 'dd.MM.yyyy') {
		if (date.search(",") !== -1) {
			date = date.replace(",", ".");
			date = date.replace(",", ".");
		}

		if (date.length === pattern.length) {
			return date;
		}

		if (date.search("\\.") !== -1) {
			newDateSplit = date.split(".");
			if (newDateSplit.length !== 3) {
				return date;
			}

			if (newDateSplit[0].length === 1) {
				newDate = "0" + newDateSplit[0];
			} else {
				newDate = newDateSplit[0];
			}
			newDate += ".";
			if (newDateSplit[1].length === 1) {
				newDate += "0" + newDateSplit[1];
			} else {
				newDate += newDateSplit[1];
			}
			newDate += ".";
			if (newDateSplit[2].length === 2) {
				year = parseInt(newDateSplit[2], 10) + 2000;
				if (2030 > year) {
					newDate += "20" + newDateSplit[2];
				} else {
					newDate += "19" + newDateSplit[2];
				}
			} else if (newDateSplit[2].length === 4) {
				newDate += newDateSplit[2];
			}
		} else {
			if (date.length === 8) {
				newDate = date.substring(0, 2);
				newDate += "." + date.substring(2, 4);
				newDate += "." + date.substring(4, 8);
			} else if (date.length === 6) {
				newDate = date.substring(0, 2);
				newDate += "." + date.substring(2, 4) + ".";
				year = parseInt(date.substring(4, 6), 10) + 2000;
				if (2030 > year) {
					newDate += "20" + date.substring(4, 6);
				} else {
					newDate += "19" + date.substring(4, 6);
				}
			} else {
				return date;
			}
		}
		return newDate;
	}
}

window.isIpad = function () {
	return navigator.userAgent.match(/iPad/i) != null;
}

window.isIphone = function () {
	return navigator.userAgent.match(/iPhone/i) != null;
}
